import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2f4d9d62")

_pushScopeId("data-v-2f4d9d62")
const _hoisted_1 = { class: "mypagefavoritefoods-page" }
const _hoisted_2 = { class: "mypagefavoritefoods-page-contents" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MypageFoodListItem = _resolveComponent("MypageFoodListItem")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isNoElement)
        ? (_openBlock(), _createBlock("div", _hoisted_3))
        : (_openBlock(), _createBlock("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foodList, (food) => {
              return (_openBlock(), _createBlock(_component_MypageFoodListItem, {
                key: food.id,
                foodId: food.id,
                foodImage: food.imageUrl,
                foodName: food.name,
                isFavorite: food.isFavorite,
                onClickItem: _ctx.clickItem,
                onClickFavorite: _ctx.clickFavorite,
                onClickShopinglist: _ctx.clickShoppingList
              }, null, 8, ["foodId", "foodImage", "foodName", "isFavorite", "onClickItem", "onClickFavorite", "onClickShopinglist"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
    ]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})